import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const ServiceUnavailablePage = () => (React.createElement("div", { className: "service-unavailable-page" },
    React.createElement(SVGIcon, { icon: SVGIcons.MESSAGE_ERROR }),
    React.createElement("div", { className: "text" }, getMessage('service_unavailable_message'))));
export default ServiceUnavailablePage;
